import { render, staticRenderFns } from "./RequerimientosReclamacion.vue?vue&type=template&id=ffc0c4f8&"
import script from "./RequerimientosReclamacion.vue?vue&type=script&lang=js&"
export * from "./RequerimientosReclamacion.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientosReclamacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports